import { useParams } from "react-router";

import { useClientPreferences } from "@/lib/hooks/use-portfolio-collections";

import { TableCardSkeleton } from "../skeleton-loaders";
import { ClientPreferencesTable } from "./client-preferences-table";

export default function ClientPreferencesPage() {
  const { id } = useParams<{ id: string }>();
  const { clientPreferences, isLoading } = useClientPreferences(id!);

  if (isLoading) {
    return <TableCardSkeleton columns={2} />;
  }

  return (
    <ClientPreferencesTable portfolioCollectionId={id!} clientPreferences={clientPreferences} />
  );
}
